import { useLocalStorageManager } from '~/features-generic/config-manager/utils/local-storage-manager'

export const useLastVisitedAIConversation = createGlobalState(
  () => useLocalStorageManager<string>('last_visited_ai-conversation', ''),
)
